import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricLivePricingConfigIssueCount extends MetricBase {
    constructor() {
        super({
            field: "metric_livePricingConfigIssueCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.livePricingConfigIssueCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.livePricingConfigIssueCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.livePricingConfigIssueCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricLivePricingConfigIssueCount;
